import { styledByTheme } from '../../../../themes/architecture/styled-by-theme';
import { LiveStreamingVideoContainerDefaultBox } from './live-streaming-video-container.default.box';

export const LiveStreamingVideoContainerBox = styledByTheme(LiveStreamingVideoContainerDefaultBox).apply();;